module.exports = __webpack_public_path__ + "static/images/styles/images/buildings/military-school-lvl3-100.6d44d26d.png";


//////////////////
// WEBPACK FOOTER
// ./styles/images/buildings/military-school-lvl3-100.png
// module id = 3549
// module chunks = 11